<template lang="pug">
  .title-screen
    .title-screen__header
      main-header(
        logo-white
      )
    .title-screen__body
      .container
        .title-screen__title
          h1.title {{ translation.title_screen.main_title }}
        .title-screen__subtitle
          h2.subtitle(v-html="translation.title_screen.title")
        .title-screen__form.hide-xs-up
          .search-form.search-form_big
            .search-form__elem
              .search-form-elem
                .search-form-elem__body
                  router-link.button.button_paint-main(
                    to="/pages/camps/"
                  )
                    .button__text Выбрать лагерь
        .title-screen__form.hide-xs
          search-form(
            big
          )
        .title-screen__features
          ul.title-screen-features
            li.title-screen-features__item(v-html="translation.title_screen.camp_count")
            li.title-screen-features__item(v-html="translation.title_screen.shift_count")
            li.title-screen-features__item(v-html="translation.title_screen.programs_count")
            li.title-screen-features__item(v-html="translation.title_screen.days_count")
</template>

<script>
import {mapState} from "vuex";

import mainHeader from "@/components/header/Header.vue";
import searchForm from "@/components/searchForm/SearchForm.vue";

export default {
  name: "TitleScreen",
  components: {
    mainHeader,
    searchForm
  },
  computed: {
    ...mapState(["translation"])
  }
};
</script>
